namespace $ {

	export function $shm_projects_access_view( project_id: string ) { return true }
	export function $shm_projects_access_prerelease( project_id: string ) { return true }
	export function $shm_projects_access_release( project_id: string ) { return true }
	export function $shm_projects_users_options() { return {} as Record< string, string > }

}
